import { render, staticRenderFns } from "./Total60DayCreditListofOutletsReport.vue?vue&type=template&id=6d440b67&"
import script from "./Total60DayCreditListofOutletsReport.vue?vue&type=script&lang=js&"
export * from "./Total60DayCreditListofOutletsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports